import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class PassengersReportService {
  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) { }

  vpcReport(imeis, dateIni, dateFin, rfidOnly, drivers, routes): Promise<any> {

    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/vpcReport';
    var data = {
      imeis : imeis,
      dateIni : dateIni,
      dateFin : dateFin,
      user_account : this.commonService.getUserName(),
      rfid_only : rfidOnly,
      drivers:drivers,
      routesId : routes
    }

    return this.http.post(url, data, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  driverReport(imeis, drivers, dateIni, dateFin): Promise<any> {

    const url = this.commonService.getPrefixUrlService() + 'Service.svc/driverReport';
    var data = {
      imeis : imeis,
      drivers:drivers,
      dateIni : dateIni,
      dateFin : dateFin,
      user_account : this.commonService.getUserName(),
    }

    return this.http.post(url, data, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

 

  dispatcherReport(imeis, dateIni, dateFin, rfidOnly, drivers, dispatchersId, dispatcherType, id_route): Promise<any> {

    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/dispatcherReport';
    var data = {
      imeis : imeis,
      dateIni : dateIni,
      dateFin : dateFin,
      user_account : this.commonService.getUserName(),
      rfid_only : rfidOnly,
      drivers:drivers,
      dispatchersId: dispatchersId,
      dispatcherTypeId : dispatcherType,
      routesId : id_route
    }

    return this.http.post(url, data, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  vpcReportOld(imeis, dateIni, dateFin): Promise<any> {

    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/vpcReportOld/' + imeis + "/" + dateIni + "/" + dateFin;

    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  vpcReportTime(imei, dateIni, dateFin): Promise<any> {

    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/vpcReportTime/' + imei + '/' + dateIni + '/' + dateFin;
    console.log('vpcReportTime service ' , url)
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }


  vpcReportTime_new(imeis, dateIni, dateFin, pointsId, driversId): Promise<any>{
    var data = {
      imeis : imeis,
      dateIni : dateIni,
      dateFin : dateFin,
      user_account : this.commonService.getUserName(),
      points : pointsId,
      drivers : driversId
    }
    return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/vpcReportTime',
      JSON.stringify(data), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        if (response && response['message']) {
          //this.alertService.success(response['message']);
          } else {
          //this.alertService.error('error')
        }
        return response;
      });
  }


  vpcReportTimeAll(userAccount, dateIni, dateFin): Promise<any> {

    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/vpcReportTimeAll/' + userAccount + '/' + dateIni + '/' + dateFin;
    console.log('vpcReportTime service ' , url)
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
  vpcReportAll(userAccount, dateIni, dateFin): Promise<any> {

    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/vpcReportAll/' + userAccount + '/' + dateIni + '/' + dateFin;
    console.log('vpcReportTime service ' , url)
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
  getPlates(userAccount): Promise<any> {
    // const idPlate = '861693033912148';
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getPlates/' + userAccount;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  vpcReport1(plate): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/vpcReport';
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/passengers-report.service.ts